export const PROJECT_DURATION_OPTIONS = [
    {
        id: 'SHORT',
        max: 7,
        min: 1,
        title: 'Less than 1 week',
    },
    {
        id: 'WEEK',
        max: 28,
        min: 8,
        title: '1-4 weeks',
    },
    {
        id: 'MONTH',
        max: 90,
        min: 29,
        title: '1-3 months',
    },
    {
        id: 'QUARTER',
        max: 180,
        min: 91,
        title: '3-6 months',
    },
    {
        id: 'LONG',
        max: 360,
        min: 181,
        title: `Longer than 6 months`,
    },
];
export const MINIMUM_HOURLY_RATE_LABELS = Object.freeze({
    '25': '$25 - $50/hr',
    '50': '$50 - $75/hr',
    '75': '$75 - $100/hr',
    '100': '$100 - $150/hr',
    '150': '$150 - $200/hr',
    '200': '$200 - $250/hr',
    '250': '$250 - $300/hr',
    '300': '$300 - $350/hr',
    '350': '$350 - $400/hr',
    '400': '$400 - $450/hr',
    '450': '$450 - $500/hr',
    '500': '$500+/hr',
});
//# sourceMappingURL=constants.js.map